/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import OptionIcon from 'assets/icons/options-icon'
import ExternalLinkIcon from 'assets/icons/external-link-icon'
import { ecoBioRegionRestricted } from 'constants/ecoBioRegionRestricted'
import capitalize from 'utils/capitalize'
import capitalizeFirstLetterString from 'utils/capitalizeFirstLetter'
import { specieAssessmentParameterType } from 'constants/speciesParameterType'

import { ReportsFactsheetIconWrapper, ReportsFactsheetWrapper, ReportsIucnStatusWrapper } from '../style'
import { SortingArrowWrapper } from 'components/SortingArrow/style'
import {renderSitesStatusIcon} from '../../SitesManagement/sitesTable'
import { getStickyTableColumnsLength } from 'utils/getStickyTableColumnsLength'


export const renderReportsIucnStatusIcon = (status) => {
  const color = {
    EX: '#FFFFFF',
    EW: 'rgba(84, 35, 68, 0.3)',
    CR: 'rgba(216, 30, 5, 0.5)',
    EN: 'rgba(252, 127, 63, 0.6)',
    VU: 'rgba(249, 232, 20, 0.6)',
    LR: 'rgba(226, 211, 105, 0.8)',
    NT: 'rgba(204, 226, 38, 0.6)',
    LC: 'rgba(96, 198, 89, 0.6)',
    DD: '#D1D1C6'
  }

  return (
    <ReportsIucnStatusWrapper color={color[status]}>
      <FormattedMessage id={status} />
    </ReportsIucnStatusWrapper>
  )
}

export const makeSpeciesTabRow = (speciesTableData) => {
  return speciesTableData.map((item) => {
    const siteStatus = item.kbaStatus
    const ecoBioRegion = ecoBioRegionRestricted.find((ecoBioId) => {
      return ecoBioId.id === item.EcoBioRegionRestrictedId
    })
    const assessmentParameter = specieAssessmentParameterType.find((paramId) => {
      return paramId.id === item.SiteAssesmentParameterTypeId
    })

    return {
      siteCode: item.SiteId,
      region: item.region.join(', '),
      country: item.country.join(', '),
      siteName: item.siteName,
      siteNameNational: item.siteNameNational,
      SiteStatusId: (
        <>
          {renderSitesStatusIcon(siteStatus)}
          {capitalize(siteStatus)}
        </>
      ),
      kbaClassification: item.kbaClassification,
      commonName: `${capitalizeFirstLetterString(item.specieName)}`,
      scientificName: item.scientificName,
      taxonomicGroup: item.taxonomicGroup,
      iucnStatus: item.RedListCategoryCode? renderReportsIucnStatusIcon(item.RedListCategoryCode) : '-',
      redListCrit: item.IUCNRedListCriteria ? item.IUCNRedListCriteria : '-',
      restrictedRangeStatus: item.rangeRestricted ? 'Yes' : 'No',
      ecoregionBioregionRestricted: ecoBioRegion ? capitalize(ecoBioRegion.name) : '-',
      parameter: assessmentParameter ? capitalize(assessmentParameter.name) : '-',
      bestGlobalEstimate: item.bestGlobal ? item.bestGlobal : '-',
      earliestYear: item.earliestDataSetYear ? item.earliestDataSetYear : '-',
      siteEstimate: item.bestSite ? item.bestSite : '-',
      reproductiveUnits: item.minReproductiveUnits ? item.minReproductiveUnits : '-',
      sourceReproductiveUnits: item.ruSource,
      SpeciesCriteriaTriggered:  item.kbaCriterias ? item.kbaCriterias.join(', ') : '-',
      options: <ReportsFactsheetWrapper>
        <ReportsFactsheetIconWrapper>
          <ExternalLinkIcon />
        </ReportsFactsheetIconWrapper>
        <ReportsFactsheetIconWrapper>
          <OptionIcon />
        </ReportsFactsheetIconWrapper>
      </ReportsFactsheetWrapper>
    }
  })
}

export const makeSpeciesTabColumns = (sorting, setSorting, rows) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortBySiteID = () => {
    sortFunction('siteCode')
  }

  const sortBySiteCountry = () => {
    sortFunction('SiteDetailsCountryId')
  }

  const sortBySiteNameEnglish = () => {
    sortFunction('name')
  }

  const sortBySiteNameNational = () => {
    sortFunction('siteNameNational')
  }

  const sortBySiteStatus = () => {
    sortFunction('SiteStatusId')
  }

  const sortBySiteName = () => {
    sortFunction('specieName')
  }

  const sortBySiteScientificName = () => {
    sortFunction('scientificName')
  }

  const sortBySiteTaxonomicGroup = () => {
    sortFunction('taxonomicGroup')
  }

  const sortByIucnRedListCategory = () => {
    sortFunction('IUCNRedListCriteria')
  }

  const sortByIucnRedListCriteria = () => {
    sortFunction('RedListCategoryCode')
  }

  const sortByRestrictedStatus = () => {
    sortFunction('rangeRestricted')
  }

  const sortByEcoBioRestricted = () => {
    sortFunction('EcoBioRegionRestrictedId')
  }

  const sortByAssessmentParameter = () => {
    sortFunction('SiteAssesmentParameterTypeId')
  }

  const sortByBestGlobal = () => {
    sortFunction('bestGlobal')
  }

  const sortByEarliestDataSetYear = () => {
    sortFunction('earliestDataSetYear')
  }

  const sortByBestSite = () => {
    sortFunction('bestSite')
  }

  const sortByReproductiveUnits = () => {
    sortFunction('minReproductiveUnits')
  }

  const sortByRuSource = () => {
    sortFunction('ruSource')
  }

  return [
    {
      id: 'siteCode',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteId' />
          <SortingArrow
            onChange={sortBySiteID}
            checked={sorting.sortBy === 'siteCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteCode',
      width: 100,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'region',
      header: (
        <>
          <FormattedMessage id='region' />
        </>
      ),
      accessorKey: 'region',
      width: getStickyTableColumnsLength('region', rows),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      header: (
          <SortingArrowWrapper>
          <FormattedMessage id='countryLabel' />
          <SortingArrow
            onChange={sortBySiteCountry}
            checked={sorting.sortBy === 'SiteDetailsCountryId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'country',
      width: getStickyTableColumnsLength('country', rows, 150, true),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteNameEng' />
          <SortingArrow
              onChange={sortBySiteNameEnglish}
              checked={sorting.sortBy === 'name' && sorting.sortDirection === sortDirection.ASC}
            />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      width: getStickyTableColumnsLength('siteName', rows, 200),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteNameNational',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteNameNational' />
          <SortingArrow
              onChange={sortBySiteNameNational}
              checked={sorting.sortBy === 'siteNameNational' && sorting.sortDirection === sortDirection.ASC}
            />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteNameNational',
      width: getStickyTableColumnsLength('siteNameNational', rows, 200),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SiteStatusId',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaStatus' />
          <SortingArrow
              onChange={sortBySiteStatus}
              checked={sorting.sortBy === 'SiteStatusId' && sorting.sortDirection === sortDirection.ASC}
            />
        </SortingArrowWrapper>
      ),
      accessorKey: 'SiteStatusId',
      width: 180,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaClassification',
      header: (
        <>
          <FormattedMessage id='kbaClassification' />
        </>
      ),
      accessorKey: 'kbaClassification',
      width: getStickyTableColumnsLength('kbaClassification', rows, 175),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'commonName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='commonName' />
          <SortingArrow
            onChange={sortBySiteName}
            checked={sorting.sortBy === 'specieName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'commonName',
      width: getStickyTableColumnsLength('specieName', rows, 166),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'scientificName',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='scientificName' />
          <SortingArrow
            onChange={sortBySiteScientificName}
            checked={sorting.sortBy === 'scientificName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'scientificName',
      width: getStickyTableColumnsLength('scientificName', rows, 166),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'taxonomicGroup',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='taxonomicGroup' />
          <SortingArrow
            onChange={sortBySiteTaxonomicGroup}
            checked={sorting.sortBy === 'taxonomicGroup' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'taxonomicGroup',
      width: getStickyTableColumnsLength('taxonomicGroup', rows, 180),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'iucnStatus',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='iucnStatus' />
          <SortingArrow
            onChange={sortByIucnRedListCategory}
            checked={sorting.sortBy === 'IUCNRedListCriteria' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'iucnStatus',
      width: 155,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'redListCrit',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='redListCrit' />
          <SortingArrow
            onChange={sortByIucnRedListCriteria}
            checked={sorting.sortBy === 'RedListCategoryCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'redListCrit',
      width: getStickyTableColumnsLength('IUCNRedListCriteria', rows),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'restrictedRangeStatus',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='restrictedRangeStatus' />
          <SortingArrow
            onChange={sortByRestrictedStatus}
            checked={sorting.sortBy === 'rangeRestricted' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'restrictedRangeStatus',
      width: 195,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'ecoregionBioregionRestricted',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='ecoregionBioregionRestricted' />
          <SortingArrow
            onChange={sortByEcoBioRestricted}
            checked={sorting.sortBy === 'EcoBioRegionRestrictedId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'ecoregionBioregionRestricted',
      width: 275,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'parameter',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='parameter' />
          <SortingArrow
            onChange={sortByAssessmentParameter}
            checked={sorting.sortBy === 'SiteAssesmentParameterTypeId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'parameter',
      width: 240,
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'bestGlobalEstimate',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='bestGlobalEstimate' />
          <SortingArrow
            onChange={sortByBestGlobal}
            checked={sorting.sortBy === 'bestGlobal' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'bestGlobalEstimate',
      width: getStickyTableColumnsLength('bestGlobal', rows, 197),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'earliestYear',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='earliestYear' />
          <SortingArrow
            onChange={sortByEarliestDataSetYear}
            checked={sorting.sortBy === 'earliestDataSetYear' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'earliestYear',
      width: getStickyTableColumnsLength('earliestDataSetYear', rows, 235),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteEstimate',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteEstimate' />
          <SortingArrow
            onChange={sortByBestSite}
            checked={sorting.sortBy === 'bestSite' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteEstimate',
      width: getStickyTableColumnsLength('bestSite', rows, 185),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'reproductiveUnits',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='reproductiveUnits' />
          <SortingArrow
            onChange={sortByReproductiveUnits}
            checked={sorting.sortBy === 'minReproductiveUnits' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'reproductiveUnits',
      width: getStickyTableColumnsLength('minReproductiveUnits', rows, 117),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'sourceReproductiveUnits',
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='sourceReproductiveUnits' />
          <SortingArrow
            onChange={sortByRuSource}
            checked={sorting.sortBy === 'ruSource' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'sourceReproductiveUnits',
      width: getStickyTableColumnsLength('ruSource', rows, 140),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SpeciesCriteriaTriggered',
      header: (
        <>
          <FormattedMessage id='SpeciesCriteriaTriggered' />
        </>
      ),
      accessorKey: 'SpeciesCriteriaTriggered',
      width: getStickyTableColumnsLength('kbaCriterias', rows),
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'options',
      header: (
        <>
          <FormattedMessage id='factsheet' />
        </>
      ),
      accessorKey: 'options',
      width: 100,
      cell: ({ getValue }) => getValue()
    }
  ]
}
